<template>
  <div class="DoorCost flex">
    <div class="mr-default" style="width: 250px">
      <ATable
        ref="table_product"
        :data="door_items"
        max-height="722px"
        highlight-current-row
        hide-button-insert
        border
        hide-top-panel
        hide-pagination
        @cell-click="handleCellClickProduct"
      >
        <el-table-column
          type="index"
          label="No"
          :index="handleProductIndex"
          :width="$width.indexw"
        />
        <el-table-column prop="name" label="품목명" />
      </ATable>
    </div>
    <div style="width:calc(100% - 260px);">
      <ATable
        ref="table"
        :data="items"
        :buttonsWidth="'400px'"
        max-height="722px"
        highlight-current-row
        hide-button-insert
        border
        hide-top-panel
        hide-pagination
      >
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.indexw"
        />
        <el-table-column
          prop="size_type_flag"
          label="구분"
          width="100"
          :formatter="resolveSizeTypeFlag"
        >
          <template slot-scope="scope">
            <ASelector
              v-model="scope.row.size_type_flag"
              :disabled="!has_grant_write"
              :items="size_type_flags"
            />
          </template>
        </el-table-column>
        <el-table-column prop="size_begin" label="규격시작" width="100">
          <template slot-scope="scope">
            <ANumberInput
              v-model="scope.row.size_begin"
              :disabled="!has_grant_write"
            />
          </template>
        </el-table-column>
        <el-table-column prop="size_end" label="규격종료" width="100">
          <template slot-scope="scope">
            <ANumberInput
              v-model="scope.row.size_end"
              :disabled="!has_grant_write"
            />
          </template>
        </el-table-column>
        <el-table-column prop="price" label="단가">
          <template slot-scope="scope">
            <ANumberInput
              v-model="scope.row.price"
              :disabled="!has_grant_write"
            />
          </template>
        </el-table-column>
        <el-table-column
          class-name="cell-number"
          v-for="level in table_customer_door_level"
          :key="level.id"
          :label="level.code"
          :prop="'price_' + level.id"
        >
          <template slot-scope="scope">
            <ANumberInput
              v-model="scope.row.custom[level.id].price"
              :disabled="!has_grant_write"
            />
          </template>
        </el-table-column>
        <el-table-column prop="assemble_price" label="조립비">
          <template slot-scope="scope">
            <ANumberInput
              v-model="scope.row.assemble_price"
              :disabled="!has_grant_write"
            />
          </template>
        </el-table-column>
        <el-table-column label="명령" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              :disabled="!has_grant_write"
              :loading="load_button"
              @click="handleClickAdd(scope.$index)"
              >추가</el-button
            >
            <el-button
              type="danger"
              size="mini"
              v-if="scope.$index > 0"
              :disabled="!has_grant_write"
              :loading="load_button"
              @click="handleClickRemove(scope.$index)"
              >삭제</el-button
            >
          </template>
        </el-table-column>
        <div slot="buttons" style="width: 400px;">
          <el-button
            type="primary"
            size="mini"
            :disabled="!has_grant_write"
            :loading="load_button"
            @click="handleClickRegister"
            >저장</el-button
          >
          <el-button
            size="mini"
            :disabled="!has_grant_write"
            @click="handleClickCancel"
            >취소</el-button
          >
          <el-button
            size="mini"
            :disabled="!has_grant_write"
            @click="handleClickExportExcel"
            >엑셀 내보내기</el-button
          >
          <el-upload
            class="inline ml-default"
            action="#"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="handleOnChange"
          >
            <el-button type="primary">단가 엑셀 등록</el-button>
          </el-upload>
        </div>
      </ATable>
    </div>
    <el-dialog
      title="일부 항목 등록 실패"
      width="600px"
      :visible.sync="excel_dialog_visible"
      destroyOnClose
    >
      <ATable
        class="no-pointer"
        :data="items_fail"
        border
        hide-top-panel
        hide-button-insert
        hide-pagination
      >
        <el-table-column prop="name" label="품목명" />
        <el-table-column prop="size_type_flag" label="구분" />
        <el-table-column label="실패 이유" :formatter="resolveReason" />
      </ATable>
      <el-button type="primary" @click="handleClickRegisterByExcel"
        >저장<AHelper type="warning"
          >저장 시 실패한 항목 외 항목을 저장합니다.</AHelper
        ></el-button
      >
      <el-button @click="handleClickClose" class="ml-default">취소</el-button>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { base_data } from "@/common/mixins/base_data";
import XLSX from "xlsx";

export default {
  name: "DoorCost",
  mixins: [base_data],
  data() {
    return {
      title: this.$t("title.door_cost"),
      selected_data: null,
      product_id: 0,
      items: [],
      base_data: ["table_product_door_price"],
      new_id: 0,
      size_type_flags: [
        { id: "1", name: "가로" },
        { id: "2", name: "세로" },
      ],
      deleted: [],
      load_button: false,
      excel_dialog_visible: false,
      items_fail: [],
      saveItems: [],
      excelProductInfo: [
        "품목",
        "구분",
        "규격시작",
        "규격종료",
        "단가",
        "조립비",
      ],
    };
  },
  props: {
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "table_product",
      "table_product_door_price",
      "table_customer_door_level",
    ]),
    door_items() {
      return this.table_product.filter((p) => p.kind === "DOOR");
    },
  },
  mounted() {
    if (this.door_items.length > 0) {
      let item = this.door_items[0];
      this.$refs.table_product.setCurrentRow(item);
      this.handleCellClickProduct(item);
    }
  },
  methods: {
    init() {
      let items = this.util.clone(
        this.table_product_door_price.filter(
          (p) => p.product_id === this.product_id
        )
      );
      items.sort((a, b) => {
        if (a.size_type_flag !== b.size_type_flag) {
          return a.size_type_flag - b.size_type_flag;
        } else {
          return a.size_begin - b.size_begin;
        }
      });
      items.forEach((item) => {
        item.custom = [];
        this.table_customer_door_level.forEach((cl) => {
          let custom = item.customers.find(
            (c) => c.customer_door_level_id === cl.id
          );
          if (custom) {
            item.custom[cl.id] = Object.assign({}, custom);
          } else {
            item.custom[cl.id] = {
              customer_door_level_id: cl.id,
              ratio_flag: "N",
              price: 0,
            };
          }
        });
      });
      if (items.length < 1) {
        items.push(this.getNewItem(0));
      }
      this.items = items;
    },
    getNewItem(index) {
      let current_item = null;
      if (this.items.length - 1 >= index) {
        current_item = this.items[index];
      }
      let item = {
        id: this.new_id--,
        size_type_flag: current_item ? current_item.size_type_flag : "1",
        price: 0,
        assemble_price: 0,
        custom: [],
      };
      this.table_customer_door_level.forEach((cl) => {
        item.custom[cl.id] = {
          customer_door_level_id: cl.id,
          ratio_flag: "N",
          price: 0,
        };
      });
      return item;
    },
    doRegister() {
      let bad = this.items.find((item) => !item.size_begin || !item.size_end);
      if (bad) {
        this.util.notify_warning(
          this,
          this.title,
          "규격시작과 규격종료를 모두 입력해 주세요."
        );
        return;
      }
      bad = this.items.find((item) => item.size_begin >= item.size_end);
      if (bad) {
        this.util.notify_warning(
          this,
          this.title,
          "규격시작이 규격종료보다 작거나 같을 수 없습니다."
        );
        return;
      }
      let items = this.items.sort(this.sortItem);
      for (let i = 0; i < items.length; i++) {
        if (i >= items.length - 1) {
          break;
        }
        let source = items[i];
        let target = items[i + 1];
        if (source.size_type_flag === target.size_type_flag) {
          if (source.size_end >= target.size_begin) {
            this.util.notify_warning(
              this,
              this.title,
              "중복되는 구간이 존재합니다."
            );
            return;
          }
        }
      }
      items.forEach((item) => {
        item.product_id = this.product_id;
        item.customers = [];
        for (let key in item.custom) {
          if (item.custom[key].price) {
            item.customers.push(item.custom[key]);
          }
        }
      });
      let param = {
        details: items,
        deleted: this.deleted,
      };
      this.load_button = true;
      this.api.saveProductDoorPrice(param).then((res) => {
        this.load_button = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.new_id = 0;
        this.deleted = [];
        this.util.notify_success(
          this,
          this.title,
          this.$t("message.success_register")
        );
      });
    },
    sortItem(a, b) {
      if (a.size_type_flag != b.size_type_flag) {
        return a.size_type_flag - b.size_type_flag;
      } else {
        return a.size_begin - b.size_begin;
      }
    },
    resolveSizeTypeFlag(row) {
      return row.size_type_flag === "2" ? "세로" : "가로";
    },
    handleProductIndex(index) {
      return this.$refs.table_product.indexResolver(index);
    },
    handleCellClickProduct(item) {
      this.selected_data = item;
      this.product_id = item.id;
      this.new_id = 0;
      this.deleted = [];
      this.init();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickAdd(index) {
      this.items.splice(index + 1, 0, this.getNewItem(index));
    },
    handleClickRemove(index) {
      let item = this.items[index];
      if (item.id > 0) {
        this.deleted.push(item.id);
      }
      this.items.splice(index, 1);
    },
    handleClickRegister() {
      this.doRegister();
    },
    handleClickCancel() {
      this.init();
    },
    parseData(header) {
      const excelData = [];
      this.items.forEach((item) => {
        /**
         * 기계등급관리 메뉴에서 설정되는 정보에 따라 table_customer_glass_level 값이 변경됨
         * excel 에 저장하기 위해서는 header 순서에 따라 적용된 값의 순서도 같아야 함
         * 그래서 적용될 값의 순서를 정렬하기 위해 index 값을 숫자로 정의함
         * table_customer_glass_level 의 id 값에 100 을 더해 앞에
         * product code(코드), name(품목명), color(색상), thick(두께), price(기본가) 정보가 먼저 오도록 정의함
         */
        const rowData = {
          1: this.selected_data.name, // product name
          2: this.size_type_flags.find((stf) => stf.id === item.size_type_flag)
            .name, // 구분
          3: item.size_begin ? this.util.addComma(item.size_begin) : 0, // 규격시작
          4: item.size_end ? this.util.addComma(item.size_end) : 0, // 규격종료
          5: item.price ? this.util.addComma(item.price) : 0, // product price
          6: item.assemble_price ? this.util.addComma(item.assemble_price) : 0, // assemble_price
        };
        this.table_customer_door_level.forEach((cl) => {
          if (header.find((f) => f === cl.code)) {
            const price = item.custom[cl.id].price;
            rowData[cl.id + 100] = this.util.addComma(price);
          }
        });
        excelData.push(rowData);
      });
      return excelData;
    },
    handleClickExportExcel() {
      const workBook = XLSX.utils.book_new();
      const header = [this.makeExcelHeaderInfo()];
      const workSheet = XLSX.utils.json_to_sheet(this.parseData(header[0]), {
        origin: "A1",
      });
      XLSX.utils.sheet_add_aoa(workSheet, header);
      XLSX.utils.book_append_sheet(workBook, workSheet, "도어단가");
      XLSX.writeFile(workBook, "도어단가관리.xlsx");
    },
    makeExcelHeaderInfo() {
      const excelHeaderInfo = this.util.deepClone(this.excelProductInfo);
      this.table_customer_door_level.forEach((item) => {
        excelHeaderInfo.push(item.code);
      });
      return excelHeaderInfo;
    },
    handleOnChange(event) {
      const file = event.raw;
      const reader = new FileReader();
      reader.onload = this.loadExcel;
      reader.readAsArrayBuffer(file);
    },
    loadExcel(e) {
      let tmpResult = {};
      let data = e.target.result;
      data = new Uint8Array(data);
      let excelFile;
      try {
        excelFile = XLSX.read(data, {
          type: "array",
          cellDates: true,
          cellNF: false,
          cellText: false,
        });
      } catch (ex) {
        this.util.notify_error(this, this.title, "엑셀 파일이 아닙니다.");
        return;
      }
      excelFile.SheetNames.forEach((sheetName) => {
        const costItems = XLSX.utils.sheet_to_json(
          excelFile.Sheets[sheetName],
          { header: 1 }, // 모든 헤더 정보를 array로 가져옴
          { raw: true, dateNF: "YYYY-MM-DD" }
        );
        if (costItems.length) tmpResult[sheetName] = costItems;
      });

      this.parseExcel(tmpResult["도어단가"]);
    },
    validHeaderIndex(excelHeaderInfo, index) {
      const headerIndex = excelHeaderInfo.findIndex(
        (f) => f === this.excelProductInfo[index]
      );
      if (headerIndex < 0) {
        this.util.notify_error(
          this,
          this.title,
          "엑셀 파일에 [" + this.excelProductInfo[index] + "] 정보가 없습니다."
        );
      }
      return headerIndex;
    },
    parseExcel(result) {
      const excelItems = [];
      // 헤더 정보 분리
      const excelHeaderInfo = result.splice(0, 1)[0];
      // table_product의 name에 해당하는 '품목명' 컬럼 존재 여부 확인
      // 존재하지 않으면 excel import 종료
      // 품목명이 없으면 product 정보를 찾아서 비교 할 수 없어 진행 불가
      const headerNameIndex = this.validHeaderIndex(excelHeaderInfo, 0);
      const headerSizeTypeFlagIndex = this.validHeaderIndex(excelHeaderInfo, 1);
      const headerSizeBeginIndex = this.validHeaderIndex(excelHeaderInfo, 2);
      const headerSizeEndIndex = this.validHeaderIndex(excelHeaderInfo, 3);

      if (
        headerNameIndex === -1 ||
        headerSizeTypeFlagIndex === -1 ||
        headerSizeBeginIndex === -1 ||
        headerSizeEndIndex === -1
      )
        return;

      // table_product_price의 price에 해당하는 '평단가' 컬럼 정보의 index
      const headerPriceIndex = [];
      const items_fail = [];
      for (var nIdx = 4; nIdx < 10; nIdx++) {
        headerPriceIndex.push(
          excelHeaderInfo.findIndex((f) => f === this.excelProductInfo[nIdx])
        );
      }

      result.forEach((item) => {
        let data = {
          name: item[headerNameIndex],
          size_type_flag: item[headerSizeTypeFlagIndex],
          size_begin: item[headerSizeBeginIndex],
          size_end: item[headerSizeEndIndex],
        };
        for (var nIdx = 4; nIdx < item.length; nIdx++) {
          // '평단가' 와 명칭이 일치하는 컬럼 정보가 존재하면 정보를 가져옴
          if (headerPriceIndex[nIdx - 4] > -1) {
            switch (nIdx) {
              case 4:
                data.price = Number.parseInt(
                  this.util.removeComma(item[headerPriceIndex[nIdx - 4]])
                );
                break;
              case 5:
                data.assemble_price = Number.parseInt(
                  this.util.removeComma(item[headerPriceIndex[nIdx - 4]])
                );
                break;
            }
          }
        }

        // 현재 설정된 기계등급 정보를 기반으로 excel header 정보를 비교하여
        // 일치하는 컬럼의 정보만 가져옴
        this.table_customer_door_level.forEach((cl) => {
          const headerCustomerLevelIndex = excelHeaderInfo.findIndex(
            (f) => f === cl.code
          );
          if (headerCustomerLevelIndex > -1) {
            data[cl.id] = Number.parseInt(
              this.util.removeComma(item[headerCustomerLevelIndex])
            );
          }
        });

        let product = this.table_product.find((f) => f.name === data.name);
        const size_type_flag = this.size_type_flags.find(
          (stf) => stf.name === data.size_type_flag
        );
        if (product && size_type_flag) {
          let product_price = this.table_product_door_price.find(
            (f) =>
              f.product_id === product.id &&
              f.size_begin === data.size_begin &&
              f.size_end === data.size_end &&
              f.size_type_flag === data.size_type_flag.id
          );
          if (product_price) {
            data.product_price = JSON.parse(JSON.stringify(product_price));
          } else {
            data.product_id = product.id;
          }
          data.size_type_flag = size_type_flag.id;
          excelItems.push(data);
        } else {
          if (!product) data.product_id = null;
          else {
            data.product_id = product.id;
            data.size_type = size_type_flag;
          }
          items_fail.push(data);
        }
      });

      this.items_fail = items_fail;
      this.doRegisterByExcel(excelItems);
    },
    doRegisterByExcel(excelItems) {
      const saveItems = [];
      excelItems.forEach((item) => {
        if (item.product_price) {
          if (item.product_price.price !== item.price) {
            item.product_price.price = item.price;
          }
          if (item.product_price.assemble_price !== item.assemble_price) {
            item.product_price.assemble_price = item.assemble_price;
          }
          item.product_price.customers = this.parseCustomerPrice(item);
          saveItems.push(item.product_price);
        } else {
          item.customers = this.parseCustomerPrice(item);
          saveItems.push(item);
        }
      });
      this.saveItems = saveItems;
      if (this.items_fail.length) {
        this.excel_dialog_visible = true;
        this.loading = false;
      } else {
        this.doRegisterByExcelConfirm();
      }
    },
    handleClickRegisterByExcel() {
      this.doRegisterByExcelConfirm();
    },
    handleClickClose() {
      this.excel_dialog_visible = false;
      this.items_fail = [];
    },
    doRegisterByExcelConfirm() {
      this.handleClickClose();
      this.api.saveProductDoorPriceByExcel(this.saveItems).then((res) => {
        this.handleResult(res);
        this.saveItems = [];
      });
    },
    parseCustomerPrice(item) {
      const newCustomers = [];
      this.table_customer_door_level.forEach((cl) => {
        const excelValue = item[cl.id];
        const customerLevelItem = item.product_price
          ? item.product_price.customers.find(
              (f) => f.customer_level_id === cl.id
            )
          : null;
        if (customerLevelItem) {
          customerLevelItem.price = excelValue;
          newCustomers.push(customerLevelItem);
        } else if (excelValue) {
          const newItem = {
            id: 0,
            customer_door_level_id: cl.id,
            ratio_flag: "N",
            price: excelValue,
          };
          newCustomers.push(newItem);
        }
      });
      return newCustomers;
    },
    handleResult(res) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
    },
    resolveReason(item) {
      if (!item.product_id) {
        return "해당 품목 없음";
      } else if (!item.size_type) {
        return "해당 구분 없음";
      } else {
        return "";
      }
    },
  },
};
</script>
